import { PASSWORD_REQUIREMENTS, passwordRequirementStatus } from "@/lib/password-requirements";

export function PasswordRequirementChecklist({ password }: { password: string }) {
  const requirementStatus = passwordRequirementStatus(password);
  return (
    <>
      <p className="text-sm font-medium text-gray-700" id="password-requirements-label">
        Password must meet all of the following:
      </p>
      <ul
        className="text-sm text-gray-600 list-none space-y-0.5 mt-1"
        id="password-requirements"
        aria-describedby="password-requirements-label"
      >
        {PASSWORD_REQUIREMENTS.map((req) => {
          const met = requirementStatus[req.id as keyof typeof requirementStatus];
          return (
            <li
              key={req.id}
              className={met ? "text-gray-600" : "text-red-600 font-medium"}
            >
              {met ? (
                <span className="inline-flex items-center gap-1.5">
                  <span className="text-green-600" aria-hidden>
                    ✓
                  </span>
                  {req.label}
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5">
                  <span aria-hidden>✗</span>
                  {req.label}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </>
  );
}
